import Splide from "@splidejs/splide";
import GLightbox from "glightbox";
import {FloatLabels} from "@keodesign/float-labels";
import Swiper from "swiper/bundle";
import { ProportionalImageNormalisation } from "@keodesign/proportional-image-normalisation";


export function init() {
	const map_click_list = document.querySelectorAll("#map-click");
	if (map_click_list) {
		map_click_list.forEach((map_click) => {
			map_click.addEventListener("click", () => {
				// shield the map on mobile for easy scrolling
				map_click.style.display = "none";
			});
		});
	}
	setupFourColumnSlider();
	setupSlider();
	GLightbox({
		touchNavigation: true,
		loop: true,
		autoplayVideos: false
	});
	new FloatLabels(".js-float-wrap");
	ProportionalImageNormalisation(".scale-me", 60, 0.525);
	setupSwiper();
	setupProjectFilter();
	// setupMenuBG();
	scrollAnimation();
	setupSliderWithImage();
	materialWrapper();
}

export function scrollAnimation() {
	const observer = new IntersectionObserver((entries) => {
		let delay = 0;

		entries.forEach(entry => {
			const el = entry.target;

			if (entry.isIntersecting) {
				if (el.classList.contains("reset-fade")) {
					delay = 0;
				} else {
					delay += 200;
				}

				el.style.transitionDelay = `${delay}ms`;
				el.classList.add("visible");

				observer.unobserve(el);
			}
		});
	}, {
		threshold: 0,
		rootMargin: "0px 0px -10% 0px"
	});

	document.querySelectorAll(".fade-in-element").forEach(el => {
		observer.observe(el);
	});
}


export function setupSlider(){
	var elms = document.querySelectorAll(".splide.slider");
	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[i], {
			type   		: "fade",
			rewind    	: true,
			pagination	: true,
			arrows    	: false,
			autoplay	: true,
		}).mount();
	}
}

export function setupFourColumnSlider(){
	var elms = document.querySelectorAll(".splide.four-col-slider");
	for ( var i = 0; i < elms.length; i++ ) {
		new Splide( elms[i], {
			type   		: "loop",
			rewind    	: true,
			pagination	: false,
			arrows    	: false,
			autoplay	: true,
			perPage		: 4,
			padding		: "20px",
			breakpoints: {
				992: {
					perPage: 3,
				},
				576: {
					perPage: 2,
				},
			}
		}).mount();
	}
}

function updateImage(newIndex, _splide, _externalImage) {
	const activeSlide = _splide.Components.Slides.getAt(newIndex).slide;
	const innerImg = activeSlide.querySelector("img.sub-block-img");

	if (innerImg) {
		const currentImg = _externalImage.querySelector("img");
		if (currentImg) {
			// Fade out current image
			currentImg.classList.remove("fade-in");
			currentImg.classList.add("fade-out");

			currentImg.addEventListener("transitionend", function handler() {

				currentImg.removeEventListener("transitionend", handler);
				_externalImage.innerHTML = "";

				// Clone new image
				const clonedImg = innerImg.cloneNode(true);
				clonedImg.classList.remove("d-none");
				_externalImage.appendChild(clonedImg);
				// Delay before triggering fade-in
				setTimeout(() => {
					clonedImg.classList.add("fade-in");
				}, 300);
			
			});
		}else{
			// First time: just show the image with fade-in
			_externalImage.innerHTML = "";
			const clonedImg = innerImg.cloneNode(true);
			clonedImg.classList.remove("d-none");
			_externalImage.appendChild(clonedImg);
			clonedImg.classList.add("fade-in");
			
		}
	}
}

export function setupSliderWithImage(){
	const elms = document.querySelectorAll(".slider-with-image");

	for ( let i = 0; i < elms.length; i++ ) {
		const splide_el = elms[i].querySelector(".splide");
		const splide = new Splide(splide_el, {
			type   : "loop",
			perPage: 1,
			pagination	: true,
			arrows    	: false,
			autoplay	: true,
		});
		const externalImage = elms[i].querySelector(".external-image");
		// Function to update external image


		// Update on move
		splide.on("move", function (newIndex) {
			updateImage(newIndex, splide, externalImage);
		});

		// Initialize Splide
		splide.mount();

		// Show first image initially
		updateImage(splide.index, splide, externalImage);
	}

	
}


export function setupProjectFilter(){
	
	let form = document.querySelector("#project-filter");
	if(form){
		form.addEventListener("submit", () =>{
			let formElements = form.elements;

			// Loop through each form element
			for (let i = 0; i < formElements.length; i++) {
				var element = formElements[i];

				// Check if the element is an input field and is null or empty
				if (element.tagName.toLowerCase() === "select" && (element.value === null || element.value.trim() === "")) {
					// Remove the null or empty input field
					element.removeAttribute("name");
				}
			}
			// Submit the form
			form.submit();
		});
	}
}


export function setupSwiper(){
	if (document.querySelector(".block-slider")){
		const updateSliderContent = (swiper) => {
			if(swiper) {
				let _active_id = null;
				let index_currentSlide = swiper.activeIndex;
				let currentSlide = swiper.slides[index_currentSlide];
				_active_id = currentSlide.dataset.id;
		
				if(_active_id){
				
					let slide_content_list = document.querySelectorAll(".slider-content");
					slide_content_list.forEach(slide => {
						slide.classList.remove("active");
					});
		
					let active_slide_content = document.querySelector(".slider-content[data-id='" + _active_id + "']");
					active_slide_content.classList.add("active");
				}
			}
		};

		new Swiper(".swiper-container", {
			loop: true,
			direction: "vertical",
			mousewheelControl: true,
			mousewheel: true,
			slidesPerView: 3,
			slideToClickedSlide: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			scrollbar: {
				el: ".swiper-scrollbar",
				draggable: true,
				hide: false,
			},
			freeMode: true,
			grabCursor: true,
			on: {
				afterInit: (swiper) => {
					updateSliderContent(swiper);
				},
				realIndexChange: (swiper) => {
					updateSliderContent(swiper);
				},
			}
		});
	}
}

export function materialWrapper(){

	const wrapper = document.querySelector(".block-materials .material-wrapper");
	const summaryContainer = document.querySelector(".summary-container");
	const material_items = wrapper.querySelectorAll(".material-item");
	const updateMaterialContent = (event) => {
		console.log(event);
		// Find the clicked material item
		const item = event.target.closest(".material-item");
		if (!item) return;

		// Find its summary
		const summary = item.querySelector(".material-summary");
		if (!summary) return;

		// Clear previous summary
		summaryContainer.innerHTML = "";

		// Clone or move the summary outside
		const summaryClone = summary.cloneNode(true);
		summaryClone.classList.remove("d-none");
		summaryContainer.appendChild(summaryClone);
	};
	if (wrapper){
	
		wrapper.addEventListener("click", (event) => {
			updateMaterialContent(event);
		});
		material_items.forEach(item =>{
			item.addEventListener("mouseenter", (event) => {
				updateMaterialContent(event);
			});
		});
	}
}
window.addEventListener("DOMContentLoaded", init);